import { render, staticRenderFns } from "./cardInfoProfile.vue?vue&type=template&id=b58854c2&scoped=true"
import script from "./cardInfoProfile.vue?vue&type=script&lang=js"
export * from "./cardInfoProfile.vue?vue&type=script&lang=js"
import style0 from "./cardInfoProfile.vue?vue&type=style&index=0&id=b58854c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58854c2",
  null
  
)

export default component.exports